import { useAuth0 } from '@auth0/auth0-react';

import { FullPageLoading } from '../components/FullPageLoading';
import { Button } from '../components/ui/button';

/** Traduz a mensagem crua do SDK; o texto original fica como subtexto. */
function friendlyMessage(raw: string): string {
  if (/invalid state/i.test(raw)) {
    return 'A sessão de login expirou ou foi iniciada em outra aba. Tente entrar de novo.';
  }
  if (/timeout/i.test(raw)) {
    return 'O login demorou demais para responder. Tente de novo.';
  }
  return 'Não foi possível concluir o login.';
}

export default function CallbackPage() {
  const { error, loginWithRedirect } = useAuth0();

  // A navegação pós-autenticação é gerenciada pelo onRedirectCallback
  // no AuthProvider. Esta página apenas exibe loading enquanto o SDK
  // processa o callback e faz o redirect.

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--color-bg-dark)] p-6">
        <div className="max-w-sm text-center">
          <h1 className="mb-2 text-2xl font-bold text-[var(--color-error)]">
            Erro na autenticação
          </h1>
          <p className="mb-1 text-sm text-[var(--color-text-secondary)]">
            {friendlyMessage(error.message)}
          </p>
          <p className="mb-6 break-words text-xs text-[var(--color-text-muted)]">{error.message}</p>
          <div className="flex flex-col justify-center gap-2 sm:flex-row">
            {/* Recomeça a transação do zero: é a saída para "Invalid state"
                (transação órfã de outra aba ou de um reload no meio do fluxo). */}
            <Button
              className="min-h-[44px]"
              onClick={() => loginWithRedirect()}
            >
              Tentar novamente
            </Button>
            <Button
              variant="outline"
              className="min-h-[44px]"
              onClick={() => window.location.assign('/')}
            >
              Voltar ao início
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return <FullPageLoading message="Autenticando..." />;
}
